export const DHL_WEBCHAT_INIT = 'DHL_WEBCHAT_INIT';
export const DHL_WEBCHAT_UPDATE_CONFIG = 'DHL_WEBCHAT_UPDATE_CONFIG';
export const DHL_WEBCHAT_OPEN = 'DHL_WEBCHAT_OPEN';
export const DHL_WEBCHAT_CLOSE = 'DHL_WEBCHAT_CLOSE';
export const DHL_WEBCHAT_SET_GEOLOCATION =
  'DHL_WEBCHAT_SET_GEOLOCATION';
export const DHL_WEBCHAT_TEST_MESSAGE = 'DHL_WEBCHAT_TEST_MESSAGE';
export const DHL_WEBCHAT_REMOVE_SHADOW = 'DHL_WEBCHAT_REMOVE_SHADOW';
export const DHL_WEBCHAT_PUSH_ALERT = 'DHL_WEBCHAT_PUSH_ALERT';
